import { app } from '@/main';
import CustomerImport from '@/views/MarketingCenter/CustomerImport/CustomerImport.vue';
import flagKeys from '@/constants/flagKeys';

import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';
import InviteCustomerInStore from '@/views/InviteCustomerInStore/InviteCustomerInStore.vue';

const validateRouteFlag = () => {
  const businessInfo = app.$store.getters['business/getBusinessInfo'];
  const flags = app.$store.getters['flags/getFlags'];

  return (
    businessInfo &&
    businessInfo.business &&
    businessInfo.business.type === IBusinessType.INSTORE &&
    flags.includes(flagKeys.enableInStoreInviteCustomer)
  );
};

const customerImportInStore = new Route(
  '/invite-customer-in-store',
  'invite-customer-in-store',
  InviteCustomerInStore,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    customFlagValidator: validateRouteFlag,
    navbar: {
      name: 'Invite Customers',
      icon: 'invite-customers',
      description:
        'Incentivize customers to join your rewards program by sending them treats.'
    },
    pageView: {
      eventLabel: 'Invite Customers In Store'
    }
  }
);

export { customerImportInStore };
export default customerImportInStore;
